module.exports = __webpack_public_path__ + "static/img/emg-logo.9831c511.png";